import {
  createFeatureFlagsFromList,
  FEATURE_FLAGS,
  FLAGS_MAP,
} from "../feature-flag";
import { defaultConfig } from "./default";
import type { FeatureFlags } from "../feature-flag";
import type { RemoteConfigType } from "./types";

// Make every registered flag available locally without changing production defaults.
const allFeatureFlags = createFeatureFlagsFromList(Object.values(FLAGS_MAP));

export const emulatorConfig: RemoteConfigType = {
  ...defaultConfig,
  ...allFeatureFlags,
};

// Restriction flags must be off to keep all capabilities available to seeded users.
export const emulatorSeedFeatureFlags: FeatureFlags = {
  ...allFeatureFlags,
  [FEATURE_FLAGS.ALLOW_ALL_USERS_TO_ADD_COMMENTS]: false,
  [FEATURE_FLAGS.DISABLE_BASIC_USER_TRAINING_SELF_MANAGEMENT]: false,
  [FEATURE_FLAGS.DISABLE_FORM_DUPLICATION]: false,
};
